import { PartialTranslation } from '../translations';

export const hr: PartialTranslation = {
  newChat: 'Novi razgovor',
  search: 'Pretraži',
  user: 'Korisnik',
  settings: 'Postavke',
  language: 'Jezik',
  getHelp: 'Dobij pomoć',
  viewAllPlans: 'Prikaži sve planove',
  learnMore: 'Saznaj više',
  logOut: 'Odjavi se',
  chooseLanguage: 'Odaberi jezik',
  chooseYourPreferredLanguage: 'Odaberite svoj preferirani jezik',
  searchLanguages: 'Pretraži jezike...',
  autoDetect: 'Automatska detekcija',
  noLanguagesFound: 'Nema pronađenih jezika',
  askAnything: 'Pitaj bilo što',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Osobno',
  freePlan: 'Besplatni plan',
  current: 'Trenutni',
  close: 'Zatvori',
  archive: 'Arhiviraj',
  delete: 'Obriši',
  confirmDelete: 'Jeste li sigurni da želite obrisati ovaj razgovor?',
  confirmArchive: 'Jeste li sigurni da želite arhivirati ovaj razgovor?',
  deleteCannotUndo: 'Ova radnja se ne može poništiti.',
  archiveCanFind: 'Možete ga pronaći u listi arhive nakon arhiviranja.',
  
  // 资源面板
  resources: 'Resursi',
  addResource: 'Dodaj resurs',
  deleteResource: 'Obriši resurs',
  noMatchingResourcesFound: 'Nema pronađenih odgovarajućih resursa',
  noResourcesAvailable: 'Nema dostupnih resursa',
  hideResources: 'Sakrij resurse',
  showResources: 'Prikaži resurse',
  
  // 聊天输入框
  typeMessage: 'Upiši poruku...',
  thinkingOptions: 'Opcije razmišljanja',
  deleteFile: 'Obriši datoteku',
  clearSelection: 'Očisti odabir',
  addAttachment: 'Dodaj privitak',
  sendMessage: 'Pošalji poruku',
  
  // 思考模式选项
  deepInsight: 'Duboki uvid · Površinska analiza',
  deepInsightDesc: 'Brzo razumijevanje ključnih točaka',
  deepExploration: 'Duboko istraživanje · Sveobuhvatna analiza',
  deepExplorationDesc: 'Višedimenzionalno duboko istraživanje',
  deepDeconstruction: 'Duboka dekonstrukcija · Sistemski argument',
  deepDeconstructionDesc: 'Sloj po sloj progresivna analiza',
  
  // 写作模式选项
  contractReview: 'Pregled ugovora · Identifikacija rizika',
  contractReviewDesc: 'Analiza klauzula i provjera usklađenosti',
  textPolish: 'Poliranje teksta · Profesionalni izraz',
  textPolishDesc: 'Jezična optimizacija i strukturalno prilagođavanje',
  legalDocuments: 'Pravni dokumenti · Standardni nacrt',
  legalDocumentsDesc: 'Profesionalno pisanje pravnih dokumenata',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Prijava',
  register: 'Registracija',
  welcomeBack: 'Dobrodošli u LawHelper',
  loginSubtitle: 'Vaš AI asistent za pravna istraživanja',
  continueWithGoogle: 'Nastavi s Google',
  continueWithMicrosoft: 'Nastavi s Microsoft',
  continueWithWeChat: 'Nastavi s WeChat',
  orContinueWith: 'ili nastavi s',
  emailTab: 'Email',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Unesite svoj email',
  phonePlaceholder: 'Unesite broj telefona',
  codePlaceholder: 'Unesite 6-znamenkasti kod',
  sending: 'Slanje...',
  verifying: 'Provjera...',
  verify: 'Potvrdi',
  sendMagicLink: 'Pošalji čarobnu poveznicu',
  getVerificationCode: 'Dohvati kod',
  resendCode: 'Ponovno pošalji kod',
  resendIn: 'Ponovno pošalji za',
  magicLinkSent: 'Čarobna poveznica poslana je na vaš email',
  magicLinkHint: 'Poslat ćemo sigurnu poveznicu na vaš email',
  otpSent: 'Kod za potvrdu je poslan',
  agreeToTerms: 'Nastavljanjem prihvaćate naše',
  privacyPolicy: 'Pravila privatnosti',
  termsOfService: 'Uvjeti korištenja',
  and: 'i',
  privacyTitle: 'Vaša privatnost je važna',
  privacyIntro: 'Koristimo kolačiće i slične tehnologije za pružanje najboljeg iskustva.',
  essentialCookies: 'Nužni kolačići',
  essentialDesc: 'Potrebni za funkcioniranje stranice',
  analyticsCookies: 'Analitički kolačići',
  analyticsDesc: 'Pomažu nam poboljšati uslugu',
  marketingCookies: 'Marketinški kolačići',
  marketingDesc: 'Koriste se za personalizirani sadržaj',
  acceptAll: 'Prihvati sve',
  essentialOnly: 'Samo nužni',
  customize: 'Prilagodi',
  savePreferences: 'Spremi postavke',
  back: 'Natrag',
  readPrivacyPolicy: 'Pročitajte našu politiku privatnosti',
  cookiePolicy: 'Politika kolačića',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI pregled',
  aiDraft: 'AI nacrt',
  smartAssistant: 'Predložak',

  // 知识库搜索
  enableKnowledgeSearch: 'Aktiviraj pretraživanje',
  knowledgeSearchDesc: 'AI pretražuje vaše dokumente',
  clickToDisable: 'Deaktiviraj',
  clickToEnable: 'Aktiviraj',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Zatvori panel resursa',
  uploading: 'Prijenos %{fileName}...',
  processing: 'Obrada %{fileName}...',
  uploadSuccess: '✓ %{fileName} preneseno',
  uploadError: '✗ Prijenos neuspješan: %{error}',
  quickAnswer: 'Brzi odgovor',
  quickAnswerDesc: 'Brzi odgovor na jednostavna pitanja',
  cancelRequest: 'Otkaži',
  library: 'Knjižnica',
  filterAll: 'Sve',
  filterChat: 'Razgovori',
  filterReview: 'Pregled',
  filterDraft: 'Nacrt',
  filterTemplate: 'Predložak',
  filterForm: 'Obrazac',
  thinking: 'Razmišljam...',
  thinkingProcess: 'Misaoni proces',
  analyzingLegalLogic: 'Analiza pravne logike...',
  lawhelperThinking: 'Lawhelper razmišlja...',
  serviceError: 'Greška usluge',
  uploaded: 'Preneseno',
  settingsGeneral: 'Općenito',
  settingsNotifications: 'Obavijesti',
  settingsAppearance: 'Izgled',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Obavijesti o odgovorima',
  settingsResponseNotificationsDesc: 'Obavijest po završetku AI odgovora',
  settingsColorMode: 'Način boja',
  settingsLight: 'Svijetlo',
  settingsDark: 'Tamno',
  settingsSystem: 'Sustav',
  about: 'O aplikaciji',
  reviewTitle: 'Pregled dokumenta',
  exitReview: 'Izađi iz pregleda',
  uploadPrompt: 'Prenesite PDF za pregled',
  uploadButton: 'Odaberi datoteku',
  startChatConfig: 'Napišite "Pregledaj ovaj dokument"',
  reviewPlaceholder: 'Unesite poruku...',
  analyzing: 'Pregledavanje...',
  reviewComplete: 'Pregled završen',
  issuesFound: 'Pronađeno %{count} problema',
  draftTitle: 'Izrada pravnog dokumenta',
  draftPlaceholder: 'Uredite ovdje ili zatražite od AI-ja...',
  analyzingTemplate: 'Analiza predloška %{name}...',
  templateAnalyzed: '✅ Predložak %{name} analiziran!',
  templateAnalysisPrompt: 'Analiziraj ključne klauzule',
  parsingFailed: '⚠️ Neuspješna analiza datoteke.',
  generating: 'Generiranje...',
  generatedSuccess: '✅ Dokument generiran!',
  drafterWelcome: 'Dobrodošli u AI asistent za dokumente',
  drafterYouCan: 'Možete:',
  drafterUploadTemplate: 'Prenijeti predložak za AI analizu',
  drafterDescribeNeeds: 'Opisati zahtjeve dokumenta',
  drafterLetAiHelp: 'AI pomaže s ugovorima, sporazumima itd.',
  drafterExamples: 'Primjeri:',
  drafterExampleRental: '"Sastavite ugovor o najmu"',
  drafterExampleLabor: '"Ispunite ugovor o radu"',
  drafterInputPlaceholder: 'Opišite potrebe...',
  drafterThinking: 'Razmišljam...',
  drafterHistoryTitle: 'Povijest',
  drafterNoHistory: 'Nema povijesti',
  drafterNewChat: 'Novi razgovor',
  drafterHistory: 'Povijest',
  drafterRemoveAttachment: 'Ukloni privitak',
  drafterLineHeight: 'Visina retka',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Izvoz u Word (.docx)',
  drafterExportPdf: 'Izvoz u PDF',
  drafterSave: 'Spremi dokument',
  drafterDownload: 'Preuzmi dokument',
  drafterUndo: 'Poništi',
  drafterRedo: 'Ponovi',
  drafterBold: 'Podebljano',
  drafterItalic: 'Kurziv',
  drafterStrike: 'Precrtano',
  drafterUnderline: 'Podcrtano',
  drafterHighlight: 'Istakni',
  drafterLink: 'Umetni poveznicu',
  drafterAlignLeft: 'Lijevo',
  drafterAlignCenter: 'Sredina',
  drafterAlignRight: 'Desno',
  drafterAlignJustify: 'Obostrano',
  drafterList: 'Popis',
  drafterBulletList: 'Nenumerirani popis',
  drafterOrderedList: 'Numerirani popis',
  drafterTaskList: 'Popis zadataka',
  drafterOpenResource: 'Otvori resurse',
  drafterStopGeneration: 'Zaustavi generiranje',
  drafterAgentMode: 'Agent način aktivan',
  drafterAgentModeOn: 'Agent način aktivan',
  drafterAgentModeOff: 'Normalan način',
  drafterUploadAttachment: 'Prenesi privitak',
  drafterExit: 'Izađi',
  drafterConfirm: 'Potvrdi',
  drafterOpenLink: 'Otvori poveznicu',
  drafterDeleteLink: 'Obriši poveznicu',
  drafterQuote: 'Citat',
  workflowTitle: 'AI tijek rada',
  workflowRunning: 'Izvršava se...',
  workflowReady: 'Spreman',
  workflowCompleted: 'Završen',
  workflowStartFailed: 'Neuspješno pokretanje',
  workflowExecutionFailed: 'Neuspješno izvršavanje',
  workflowInterrupted: 'Tijek rada prekinut',
  workflowProcessing: 'Obrada...',
  workflowStepsCompleted: 'koraka završeno',
  workflowStepsTotal: 'Tijek rada završen (%{count} koraka)',
  acceptChanges: 'Prihvati promjene',
  rejectChanges: 'Odbaci promjene',
  changesAccepted: 'Promjene prihvaćene',
  changesRejected: 'Promjene odbačene',
  stopWorkflow: 'Zaustavi',
  restartWorkflow: 'Ponovno pokreni',
  startDrafting: 'Započni izradu',
  interrupt: 'Zaustavi',
  documentSubject: 'Tema dokumenta *',
  documentType: 'Vrsta dokumenta',
  jurisdiction: 'Nadležnost',
  specialRequirements: 'Posebni zahtjevi (opcionalno)',
  clickStartDrafting: 'Kliknite "Započni izradu"',
  docTypeContract: 'Ugovor',
  docTypeAgreement: 'Sporazum',
  docTypeNotice: 'Obavijest',
  docTypeLetter: 'Pismo',
  docTypePetition: 'Peticija',
  docTypeWill: 'Oporuka',
  docTypePowerOfAttorney: 'Punomoć',
  countryChina: 'Kina',
  countryUSA: 'SAD',
  countryGermany: 'Njemačka',
  countryJapan: 'Japan',
  countryFrance: 'Francuska',
  countryUK: 'Ujedinjeno Kraljevstvo',
  citationVerified: 'Verificirano',
  citationUnverified: 'Neverificirano',
  imageLoadFailed: 'Neuspješno učitavanje slike',
  smartDocTitle: 'Pametni asistent za dokumente',
  smartDocChatTitle: 'AI asistent za dokumente',
  smartDocDropPrompt: 'Ispustite PDF ovdje',
  smartDocSelectFile: 'Odaberi datoteku',
  smartDocOr: 'ili',
  smartDocWelcomeTitle: 'Dobrodošli u AI asistent',
  smartDocWelcomeYouCan: 'Možete:',
  smartDocUploadForAI: 'Prenijeti predložak',
  smartDocDescribeDoc: 'Opisati zahtjeve',
  smartDocLetAIDraft: 'AI pomaže s ugovorima',
  smartDocExamples: 'Primjeri:',
  smartDocExampleRental: '"Sastavite ugovor o najmu"',
  smartDocExampleLabor: '"Ispunite ugovor o radu"',
  smartDocInputPlaceholder: 'Opišite potrebe...',
  smartDocRemoveAttachment: 'Ukloni privitak',
  smartDocOpenResources: 'Otvori resurse',
  smartDocExit: 'Izađi',
  reviewStartFailed: 'Neuspješno pokretanje pregleda',
  reviewFailed: 'Pregled neuspješan',
  reviewFoundIssues: 'Pregled završen, %{count} problema.',
  cannotReadStream: 'Ne može se čitati tok',
  parseEventFailed: 'Neuspješna analiza događaja',
  errorPrefix: 'Greška',
  unknownError: 'Nepoznata greška',
  file: 'Datoteka',
  loading: 'Učitavanje...',
  localFolders: 'Lokalne mape',
  selectLocalFolder: 'Odaberi lokalnu mapu',
  reselectFolder: 'Promijeni mapu',
  addToContext: 'Dodaj u razgovor',
  saveFile: 'Spremi',
  renameFile: 'Preimenuj',
  fileSaved: 'Datoteka spremljena',
  fileRenamed: 'Datoteka preimenovana u %{name}',
  browserNotSupported: 'Preglednik ne podržava pristup mapama',
  noFolderSelected: 'Odaberite lokalnu mapu',
  scanningFolder: 'Skeniranje mape...',
  selectFileToPreview: 'Odaberite datoteku za pregled',
  aiAnalyze: 'AI analiza',
};
